// This function is used to get the ingredients for the item
// it is used to display the ingredients for the item
// for sanity sanity structure
export const getIngredients = (ingredient, language) => {
  if (language === 'fr' && Array.isArray(ingredient.ingredientsFrLocale)) {
    return {
      ingredients: ingredient.ingredientsFrLocale,
      name: ingredient?.name?.locale || '',
    };
  } else if (Array.isArray(ingredient.ingredients)) {
    return {
      ingredients: ingredient.ingredients,
      name: ingredient?.name?.locale || '',
    };
  }

  return {
    name: ingredient?.name?.locale || '',
    ingredients: [],
  };
};
